import { DirectCommunicationType, EmailTemplateDataModel } from './types';

export default class DirectCommunicationService {
  private config: any;

  constructor(config: any) {
    this.config = config;
  }

  getDirectCommunicationTemplateId = async (locationId: number, directCommType: DirectCommunicationType) => {
    const url = `${this.config.practice.url}/DirectCommunication/GetDirectCommunicationEmailTemplate` +
      `?locationId=${locationId}&directCommType=${directCommType}`;
    const response = await fetch(url, { method: 'GET', credentials: 'include', });
    return await response.text();
  }

  createDirectCommunication = async (patientId: number, templateData: EmailTemplateDataModel, attachmentFileName?: string) => {
    const url = `${this.config.practice.url}/DirectCommunication/CreateDirectCommunication`;
    const payload = {
      IdRecipient: patientId,
      FileName: attachmentFileName,
      TemplateData: templateData
    }
    const response = await fetch(url, { 
      method: 'POST', 
      credentials: 'include', 
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    return await response.json();
  }
}